import React from 'react';
import PropTypes from 'prop-types';

import { augmentClassName } from '../../../utils/GlobalCssProxy';
import { Provider as AppContextProvider } from '../../../stores/screener/screener-app-context';
import { DEFAULT_VIEWS } from '../../../shared/screener-constants';
import moduleStyles from './screener-app.module.scss';
import ScreenerTemplate from './template';

const className = augmentClassName(moduleStyles);

// eslint-disable-next-line prefer-arrow-callback
const ScreenerApp = React.memo(function ScreenerApp({
  className: classNameProp,
  channel,
  Plans,
  mockResponse,
  UrlDomain,
  UrlPrefix,
  bluetagcharacteristic,
  yyy
}) {
  let queryParams = new URLSearchParams();

  for (const [name, value] of new URLSearchParams(window.location.search)) { // make all params lowercase
    queryParams.append(name.toLowerCase(), value);
  }

  const plan = queryParams.get('planid');
  const defaultView = queryParams.get('defaultview')
    ? queryParams.get('defaultview')
    : DEFAULT_VIEWS.NONE;
  /*prodTestVariable is available for testing features in prod without endangering the prod experience */
  const prodTestVariable = queryParams.get('prodtestvariable') === 'true';
  bluetagcharacteristic = bluetagcharacteristic ? bluetagcharacteristic : queryParams.get('bluetagcharacteristic');
  const planId = plan || '';
  channel = (channel || 'public').toLowerCase().replace(/\s|-/g, ' ').trim();
  mockResponse = mockResponse === 'true';

  const containerClass = className.string('page-container');
  const classes = classNameProp ? `${classNameProp} ${containerClass}` : containerClass;

  return (
    <div className={classes} data-channel={channel}>
      <AppContextProvider
        channel={channel}
        Plans={Plans}
        mockResponse={mockResponse}
        yyy={yyy}
        queryStringPlan={planId}
        defaultView={defaultView}
        prodTestVariable={prodTestVariable}
        UrlDomain={UrlDomain}
        UrlPrefix={UrlPrefix}
        bluetagcharacteristic={bluetagcharacteristic}
      >
        <ScreenerTemplate />
      </AppContextProvider>
    </div>
  );
});

ScreenerApp.propTypes = {
  className: PropTypes.string,
  channel: PropTypes.string,
  Plans: PropTypes.array,
  mockResponse: PropTypes.string,
  UrlDomain: PropTypes.string,
  UrlPrefix: PropTypes.string,
  bluetagcharacteristic: PropTypes.string,
  yyy: PropTypes.string
};

export default ScreenerApp;
